import * as THREE from "three";

interface P {
  mesh: THREE.Mesh;
  vx: number;
  vy: number;
  vz: number;
  life: number;
}

export class Particles {
  readonly group = new THREE.Group();
  private pool: P[] = [];
  private geo = new THREE.BoxGeometry(0.12, 0.12, 0.12);

  burst(x: number, y: number, z: number, color: number, n = 12): void {
    for (let i = 0; i < n; i++) {
      const mat = new THREE.MeshLambertMaterial({ color });
      const mesh = new THREE.Mesh(this.geo, mat);
      mesh.position.set(x + 0.5, y + 0.5, z + 0.5);
      this.group.add(mesh);
      this.pool.push({
        mesh,
        vx: (Math.random() - 0.5) * 4,
        vy: Math.random() * 4 + 1,
        vz: (Math.random() - 0.5) * 4,
        life: 0.45 + Math.random() * 0.3,
      });
    }
  }

  update(dt: number): void {
    for (let i = this.pool.length - 1; i >= 0; i--) {
      const p = this.pool[i]!;
      p.life -= dt;
      p.vy -= 18 * dt;
      p.mesh.position.x += p.vx * dt;
      p.mesh.position.y += p.vy * dt;
      p.mesh.position.z += p.vz * dt;
      p.mesh.rotation.x += dt * 6;
      p.mesh.rotation.y += dt * 4;
      const s = Math.max(0, p.life * 2);
      p.mesh.scale.setScalar(s);
      if (p.life <= 0) {
        this.group.remove(p.mesh);
        (p.mesh.material as THREE.Material).dispose();
        this.pool.splice(i, 1);
      }
    }
  }
}
